import { Controller, useFormContext } from "react-hook-form";
import { FormGroup, Label, Input, FormFeedback } from "reactstrap";

type RHFCheckboxProps = {
  name: string;
  label: string;
  disabled?: boolean;
  exclusiveWith?: string;
};

const RHFCheckbox = ({
  name,
  label,
  disabled,
  exclusiveWith,
}: RHFCheckboxProps) => {
  const {
    control,
    clearErrors,
    formState: { errors },
    setValue,
  } = useFormContext();

  const err = (errors as any)?.[name]?.message as string | undefined;

  return (
    <FormGroup check>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            <Label check className="d-flex gap-2">
              <Input
                {...field}
                type="checkbox"
                checked={!!field.value}
                disabled={disabled}
                onChange={(e) => {
                  const checked = e.target.checked;
                  field.onChange(checked);

                  if (checked && exclusiveWith) {
                    setValue(exclusiveWith, false, {
                      shouldDirty: true,
                      shouldValidate: true,
                    });
                    clearErrors([name, exclusiveWith]);
                  }
                }}
                invalid={!!err}
                className="checkbox_animated"
              />
              {label}
            </Label>
            {err && <FormFeedback>{err}</FormFeedback>}
          </>
        )}
      />
    </FormGroup>
  );
};

export default RHFCheckbox;
